import React from 'react';
import { ColDef } from 'ag-grid-community';
import { DEFAULT_DATE_FILTER_OPS, DEFAULT_FILTER_OPS } from 'utils/agGrid/options';
import { NavLink } from 'react-router-dom';
import { RiskAlert } from 'ts/models/RiskAlerts.model';
import { formatDateField, NANO_TO_MILLI_FACTOR } from 'metadata/riskOverviewMetadata';

const defaultFilterOpsWithNoContainsOp = DEFAULT_FILTER_OPS.filter((op: string) => op !== 'contains');

const riskAlertsGridColDefs: ColDef<RiskAlert>[] = [
  {
    headerName: 'Alert ID',
    field: 'alertId',
    filter: 'agTextColumnFilter',
    initialWidth: 150,
    cellRenderer: ({ data }: { data: RiskAlert }) => (
      <NavLink to={`/risk_alert/${data.alertId}`}> {data.alertId} </NavLink>
    ),
    filterParams: {
      filterOptions: defaultFilterOpsWithNoContainsOp,
    },
  },
  {
    headerName: 'Transaction Time',
    field: 'transactionTime',
    filter: 'agDateColumnFilter',
    initialWidth: 200,
    filterParams: {
      filterOptions: DEFAULT_DATE_FILTER_OPS,
    },
    valueFormatter: ({ value }) => {
      const time = value?.toString();
      const mils = parseInt(
        time?.substring(0, time?.length - NANO_TO_MILLI_FACTOR),
      );
      return formatDateField(mils);
    },
  },
  {
    headerName: 'Account',
    field: 'accountNumber',
    filter: 'agTextColumnFilter',
    initialWidth: 150,
  },
  {
    headerName: 'Alert Type',
    field: 'type',
    filter: 'agTextColumnFilter',
    initialWidth: 150,
  },
  {
    headerName: 'Alert Status',
    field: 'status',
    filter: 'agTextColumnFilter',
    initialWidth: 150,
  },
  {
    headerName: 'Alert Severity',
    field: 'severity',
    filter: 'agTextColumnFilter',
    initialWidth: 150,
  },
  {
    headerName: 'Description',
    field: 'description',
    filter: 'agTextColumnFilter',
    initialWidth: 450,
    wrapText: true,
    autoHeight: true,
  },
  {
    headerName: 'Comment',
    field: 'comment',
    filter: 'agTextColumnFilter',
    initialWidth: 150,
  },
];

export default riskAlertsGridColDefs;
